import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { OCTOBER_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(OCTOBER_2025_CAMPAIGN_END_DATE);
